import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import { preOrderPeriodMaxLength } from '../../constants/preparationProfiles';
import preparationProfilesStore from '../../store/preparationProfilesStore';
import { TPreparationProfileInputs } from '../../types/preparationProfiles';
import { localeStore } from '~/mobx/localesStore';
import Input from '~/view/components/Controls/InputComponent/Input';
import Text, { TEXT } from '~/view/components/Text/Text';

interface IProps {
  title: string;
  field: TPreparationProfileInputs;
}

export const PreparationOrderSettingsInput: FC<IProps> = observer((props: IProps): ReactElement => {
  const changeTime = (field: TPreparationProfileInputs) => (value: string | undefined) => {
    const { preOrderPeriodUnit } = preparationProfilesStore.selectedProfile;

    if (field === 'preOrderPeriod' && Number(value) > preOrderPeriodMaxLength[preOrderPeriodUnit]) {
      value = String(preOrderPeriodMaxLength[preOrderPeriodUnit]);
    }

    preparationProfilesStore.changeSelectedProfile({ [field]: value });
  };

  return (
    <div className="d-flex flex-column gap-10">
      <Text text={props.title} type={TEXT.BLOCK_HEADER} required />
      <Input
        type="number"
        value={preparationProfilesStore.selectedProfile[props.field]}
        onChangeValue={changeTime(props.field)}
        validation={preparationProfilesStore.validation[props.field]}
        placeholder={localeStore.t('Value')}
        maxLength={4}
        contentClassName="preparation-setting-main__input"
      />
    </div>
  );
});
